import React from "react";
import "./dashboard-cards.css";
import {
  getEsCategorySummaries,
  isB2cSelfAssessment,
} from "../utils/esSelfAssessmentDisplay";

const EnvironmentDetailsSection = ({ data = {}, onNavigate }) => {
  const hazards = [
    { key: "esLooseRugs", label: "Loose rugs" },
    { key: "esClutterWalkways", label: "Cluttered walkways" },
    { key: "esPoorLighting", label: "Poor lighting" },
    { key: "esStairsNoRailings", label: "Stairs w/out railings" },
    { key: "esSlipperyFloors", label: "Slippery floors" },
    { key: "esNoGrabBars", label: "No grab bars" },
    { key: "esUnevenSteps", label: "Uneven /worn steps" },
    { key: "esCordsOnFloor", label: "Cords or wires on the floor" },
    { key: "esUnevenFlooring", label: "Uneven flooring" },
    { key: "esFootwearNoTraction", label: "Footwear without proper traction" },
    { key: "esNoNightlights", label: "No Nightlights" },
    { key: "esPetsUnderfoot", label: "Pets underfoot" },
    { key: "esUnstableFurniture", label: "Unstable furniture" },
    { key: "esItemsStoredImproper", label: "Items stored too high/low" },
    { key: "esOtherFallHazard", label: "Other Fall hazard" },
    { key: "esWetSlipperyFloors", label: "Wet/slippery floors" },
    { key: "esNoBathroomGrabBars", label: "No grab bars (bathroom)" },
    { key: "esSlipperyTub", label: "Slippery tub/shower" },
    { key: "esNoNonSlipStrips", label: "No non-slip mat/strips" },
    { key: "esLooseBathMats", label: "Loose bath mats" },
    { key: "esLowToiletHeight", label: "Low toilet height" },
    { key: "esLooseToiletSeat", label: "Loose toilet seat" },
    { key: "esHighTubThreshold", label: "High tub edge/threshold" },
    { key: "esBathroomPoorLighting", label: "Poor lighting (bathroom)" },
    { key: "esBathroomNoNightlight", label: "No nightlight" },
    { key: "esBathroomClutter", label: "Clutter on floors (bathroom)" },
    { key: "esItemsOutOfReach", label: "Items stored out of reach" },
    { key: "esTowelBarsForSupport", label: "Towel bars used for support" },
    { key: "esUnstableShowerChair", label: "Unstable shower chair (or none)" },
    { key: "esCrampedBathroom", label: "Small/ cramped space for movement" },
    { key: "esOtherBathroomHazard", label: "Other safety hazard (bathroom)" },
    { key: "esKitchenWetFloors", label: "Wet/slippery floors (kitchen)" },
    { key: "esGreaseOnFloor", label: "Grease/oil on floor" },
    { key: "esLooseKitchenMats", label: "Loose kitchen mats" },
    { key: "esNoNonSlipBacking", label: "No non-slip backing" },
    { key: "esReachingHighCabinets", label: "Reaching to high cabinets" },
    { key: "esUnsafeStepStool", label: "Unsafe step stool" },
    { key: "esKitchenClutter", label: "Clutter on floor (kitchen)" },
    { key: "esNoFireExtinguisher", label: "No Fire extinguisher" },
    { key: "esBendingLowCabinets", label: "Bending to low cabinets" },
    { key: "esLooseDrawersDoors", label: "Loose or broken drawers/doors" },
    {
      key: "esFrayedCords",
      label: "Frayed or damaged electrical cords",
    },
    { key: "esKitchenPoorLighting", label: "Poor lighting (kitchen)" },
    { key: "esApplianceCordsInPath", label: "Appliance cords in path" },
    { key: "esKitchenUnevenFlooring", label: "Uneven flooring (kitchen)" },
    { key: "esOverloadedOutlet", label: "Overloaded outlet" },
    { key: "esNoSmokeDetector", label: "No smoke detector or not working" },
    { key: "esNoCO2Detector", label: "No CO2 detector or not working" },
    { key: "esOtherKitchenHazard", label: "Other safety hazard (kitchen)" },
    { key: "esStepsThresholds", label: "Steps/thresholds" },
    { key: "esNarrowHallways", label: "Narrow hallways" },
    { key: "esLayoutClutter", label: "Clutter" },
    { key: "esInaccessibleBathroom", label: "Inaccessible bathroom/bedroom" },
    { key: "esMultiLevelHome", label: "Multi-level home" },
    { key: "esTightDoorways", label: "Tight doorways" },
    { key: "esObstructedPathways", label: "Obstructed pathways" },
  ];

  const b2cSelfAssessment = isB2cSelfAssessment(data);
  const categorySummaries = b2cSelfAssessment ? getEsCategorySummaries(data) : [];
  const activeHazards = b2cSelfAssessment
    ? []
    : hazards.filter((h) => data[h.key]);

  return (
    <div className="section-container">
      {b2cSelfAssessment ? (
        <div className="hazards-summary">
          <h3>Environmental Safety (self-reported)</h3>
          <p className="text-sm text-slate-600 mb-2">
            Self-reported by family — category-level only. Individual hazard
            checklists are not shown for this assessment.
          </p>
          <div className="hazard-tags">
            {categorySummaries.map((cat) => (
              <span key={cat.id} className="hazard-tag">
                {cat.displayLine}
              </span>
            ))}
          </div>
        </div>
      ) : null}

      {!b2cSelfAssessment && activeHazards.length > 0 && (
        <div className="hazards-summary">
          <h3>Identified Hazards</h3>
          <div className="hazard-tags">
            {activeHazards.map((hazard) => (
              <span key={hazard.key} className="hazard-tag">
                {hazard.label}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EnvironmentDetailsSection;
